import { render, staticRenderFns } from "./v-hero-custom.vue?vue&type=template&id=5c9e6c4f&scoped=true&"
import script from "./v-hero-custom.vue?vue&type=script&lang=js&"
export * from "./v-hero-custom.vue?vue&type=script&lang=js&"
import style0 from "./v-hero-custom.vue?vue&type=style&index=0&id=5c9e6c4f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9e6c4f",
  null
  
)

export default component.exports